export default "__VITE_ASSET__CgE5C9MQ__"